import React from 'react'


export const Gap: React.FC<React.HTMLProps<HTMLDivElement>> = ({width, height}) => {
  return <div style={{width, height}} />
}